export const lightTheme = {
  body: "#FFF",
  text: "#363537",
  toggleBorder: "#FFF",
  buttonColor: "#FFF",
  buttonBorder: "#363537",
  background: "#363537",
};
export const darkTheme = {
  body: "#363537",
  text: "#FAFAFA",
  toggleBorder: "#6B8096",
  buttonColor: "#FFF",
  buttonBorder: "#FFF",
  background: "#999",
};
